import React, { useState } from "react";
import "../component/patientHeader.css";

import { FaPlusCircle } from "react-icons/fa";

const PatientHeader = ({ onAddPatientClicked, onSearchPatient }) => {
  const [searchValue, setSearchValue] = useState(
    localStorage.getItem("searchValue")
  );
  const [errorMessage, setErrorMessage] = useState("");

  const handleInputChange = (e) => {
    setSearchValue(e.target.value);
    e.preventDefault();
    if (errorMessage && e.target.value >= 3) {
      setErrorMessage("");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
 localStorage.setItem("searchValue",searchValue)
      e.preventDefault();
      if (searchValue.length > 3) {
       onSearchPatient(searchValue);
        setErrorMessage("");
      } else if (searchValue.length === 0) {
       onSearchPatient(searchValue);
        setErrorMessage("");
      } else {
        setErrorMessage("Pencarian membutuhkan minimal lebih dari 3 huruf");
      }
    }
  };

  return (
    <div className="patient-header-container">
      <button className="add-patient-button" onClick={onAddPatientClicked}>
        <FaPlusCircle />
        Tambah Pasien Baru
      </button>

      <div className="search-container">
        <input
          type="text"
          placeholder="Cari Pasien"
          className="search-input"
          value={searchValue}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          />
          {errorMessage && <p className="error-message">{errorMessage}</p>}
        </div>
    </div>
  );
};

export default PatientHeader;
